import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import { getProperty } from "dot-prop";
import Typography from "@mui/material/Typography";

export default function PrimarySecondaryList({
  array = [],
  hasAvatar,
  primaryId,
  primaryProp,
  secondaryId,
  secondaryProp,
}) {
  return (
    <List>
      {array.map((item, index) => {
        const { object } = item;
        const collapsedPrimaryText = item[primaryProp]?.replaceAll(" ", "");
        const primaryPropValue = getProperty(item, primaryProp);
        const secondaryPropValue = getProperty(item, secondaryProp);

        return (
          <Box key={index} display="flex" alignItems="start">
            <ListItem alignItems="flex-start" disableGutters>
              {hasAvatar && (
                <ListItemAvatar>
                  <Avatar
                    alt={primaryPropValue}
                    src={object?.host?.user?.imageUrl}
                    variant="rounded"
                  />
                </ListItemAvatar>
              )}
              <ListItemText
                disableTypography
                primary={
                  <Typography
                    id={`${primaryId}-${collapsedPrimaryText}`}
                    variant="body1"
                  >
                    {primaryPropValue}
                  </Typography>
                }
                secondary={
                  <Typography
                    id={`${secondaryId}-${collapsedPrimaryText}`}
                    variant="body2"
                  >
                    {secondaryPropValue}
                  </Typography>
                }
                sx={{ display: "flex", flexDirection: "column" }}
              />
            </ListItem>
          </Box>
        );
      })}
    </List>
  );
}
